module.exports = __webpack_public_path__ + "img/at.780476c4.jpg";